export default __webpack_public_path__ + "static/media/023-pocket watch.94b9c94c.svg";